import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import { allGuideArticles } from "@/mocks/seoContent";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  ...allGuideArticles.map(
    (article): RouteObject => ({
      path: article.slug.replace(/^\//, ''),
      element: <ArticlePage />,
    }),
  ),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;